export default __webpack_public_path__ + "static/media/table.281433ed.svg";